import { FRONTEND_ROOT, URL_ID_REGEXP } from "config/constants";

export const isInternalURL = (url) => {
  const rootUrl = FRONTEND_ROOT.match(/https?:\/\/(.*)/)[1];
  // eslint-disable-next-line no-useless-escape
  const regex = new RegExp(`^(?:https?:\/\/)?(?:${rootUrl})(?:\/.*?-|\/)?${URL_ID_REGEXP}(?:\.html){1}`, "i");
  return url.match(regex);
};

export const isStoryIdentifier = (url) => {
  const regex = /(?:^|-)(?:([0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12})|([0-9]+))(?:\.html){1}/i;
  return url.match(regex);
};



// WEBPACK FOOTER //
// ./src/utils/utils.js